import { useAuthStore, type AuthStore } from "@/Modules/Auth/Store";
import { useOnBoardingStore, type OnBoardingStore } from "@/Modules/OnBoarding/Store";
import { useUserStore, type UserStore } from "@/Modules/User/Store";
import { useChatStore, type ChatStore } from "@/Modules/Chat/Store";
import { useTherapistStore, type TherapistStore } from "@/Modules/Therapist/Store";
import { usePrivacyStore, type PrivacyStore } from "@/Modules/Privacy/Store";
import { useQuestionnaireStore, type QuestionnaireStore } from "@/Modules/Questionnaire/Store";
import { useSubscriptionStore, type SubscriptionStore } from "@/Modules/Subscription/Store";
import { usePlanStore, type PlanStore } from "@/Modules/Plan/Store";
import { useVideoCallStore, type VideoCallStore } from "@/Modules/VideoCall/Store";
import { useAgentStore, type AgentStore } from "@/Modules/Agent/Store";

import { danger, log } from "@/Utils/Debug";
import { LocalStorageService } from "@/Services/LocalStorageService";
import { LocalStorageNamespace } from "../Models/Localstorage/LocalStorageNamespace";

class ClearStoreActionHandler {
  constructor(
    private readonly authStore: AuthStore = useAuthStore(),
    private readonly userStore: UserStore = useUserStore(),
    private readonly onBoardingStore: OnBoardingStore = useOnBoardingStore(),
    private readonly chatStore: ChatStore = useChatStore(),
    private readonly therapistStore: TherapistStore = useTherapistStore(),
    private readonly privacyStore: PrivacyStore = usePrivacyStore(),
    private readonly questionnaireStore: QuestionnaireStore = useQuestionnaireStore(),
    private readonly subscriptionStore: SubscriptionStore = useSubscriptionStore(),
    private readonly planStore: PlanStore = usePlanStore(),
    private readonly videoCallStore: VideoCallStore = useVideoCallStore(),
    private readonly agentStore: AgentStore = useAgentStore(),
    private readonly authLocalStorage: LocalStorageService = new LocalStorageService(
      LocalStorageNamespace.AUTH
    ),
    private readonly onboardingLocalStorage: LocalStorageService = new LocalStorageService(
      LocalStorageNamespace.ON_BOARDING
    ),
    private readonly privacyLocalStorage: LocalStorageService = new LocalStorageService(
      LocalStorageNamespace.PRIVACY
    )
  ) {}

  public async handle(logout = true): Promise<void> {
    log("Clean stores", `isLogout ${logout}`);
    try {
      this.chatStore.clear();
      this.userStore.clearUser();
      this.onBoardingStore.resetOnboardingStore();
      this.onBoardingStore.clearLocalStorageState();
      await this.privacyStore.clear().catch((e) => danger("Error clearing privacy store", e));
      this.questionnaireStore.closeQuestionnaire();
      this.therapistStore.clear();
      this.subscriptionStore.clear();
      this.planStore.clear();
      this.videoCallStore.clean();
      this.videoCallStore.cleanRaiting();
      this.agentStore.clear();

      if (logout) {
        this.authStore.clearUserToken();
        this.authLocalStorage.clear();
        this.onboardingLocalStorage.clear();
        this.privacyLocalStorage.clear();
      }
    } catch (e) {
      danger("Error clearing stores");
    }
  }
}

export default ClearStoreActionHandler;
